<template>
	<form class="calendar_tab calendar-tab-pc">
		<div class="calendar-result ">
	  	<div class="panel panel-default">
  			<calendar-header :nameCodapp="labels[nowLang].nameCodapp" :linkDisp="false" />
        <filter-date :showTabDate="showTabDate"/>
        <div class="body-pc">
  		    <template v-for="value in filterCalendarTab({ tab: 'tab2', calendarTabRows: calendarTab2.rows })">
  				    <div class="panel-body box-tab2 add-border">
  						<div class="row set-font-tab2">
  						  	<div class="col-xs-12 font-bold">
  						  		<i class="fa fa-clock-o color-skin" aria-hidden="true"></i> <label class="text_time color-skin" >{{ value.descTime }}</label>
  						  	</div>
  						  	<div class="col-xs-12">
  						  		<i class="fa fa-map-marker i1 color-skin" aria-hidden="true"></i> <label class="text_time color-skin" >{{ value.place }}</label>
  						  	</div>
  						</div>
              <calendar-detail :description="labels[nowLang].description" :descDetail="value.descDetail"/>
  			    </div>
  		   </template>
        </div>
	  	</div>
		</div>
	</form>
</template>

<script>
import calendarHeader from 'components/calendar/calendar_header'
import filterDate from 'components/calendar/filter_date'
import calendarDetail from 'components/calendar/calendar_detail'

export default{
  name: 'calendar_tab2',
  props: [ 'calendarTab2', 'filterCalendarTab', 'nowLang' ],
  data () {
    return {
      linkToRedirect: '#',
      labels: {
        en: {
          nameCodapp: 'Appointment',
          description: 'Detail'
        },
        th: {
          nameCodapp: 'วันนัดหมาย',
          description: 'รายละเอียด'
        }
      }
    }
  },
  components: {
    calendarHeader,
    filterDate,
    calendarDetail
  }
}
</script>

<style>
  .box-tab2{
    border-bottom: 1px solid #e8e8e8;
  }
  .add-border{
    border-bottom: 1px solid #e8e8e8;
  }
</style>




// WEBPACK FOOTER //
// calendar_tab2.vue?1efdfec8